<template>
  <div style="background: #EFEFEF;" class="meta-data">
    <Row gutter="16">
      <Col span="6">
        <div class="k-card k-shadow split-box ">
          <Split
            mode="vertical"
            :lastSize.sync="dbSize"
            class="closed"
            :min="0"
          >
            <template slot="first">
              <div class="panel">
                <!-- <Button type="" style="font-size:12px;"><i class="k-icon ion-ios-search">创建数据库</i></Button> -->
                <div
                  style="padding: 0 5px 10px 8px; width: 100%;"
                  v-if="panelSize != '0px'"
                >
                  <Button
                    style="width:100%"
                    type="secondary"
                    @click="createDBClicked"
                    >创建数据库<Icon class="ion-ios-plus-outline"
                  /></Button>
                </div>
                <Tree
                  v-if="showDBTree"
                  :data="dbTree"
                  ref="dbTree"
                  :selectedKeys.sync="selectedKeys"
                  :expandedKeys.sync="expandedKeys"
                  :load="getDBTable"
                >
                  <template slot="label" slot-scope="dbTree, node">
                    <i
                      class="icon"
                      style="vertical-align: text-bottom;"
                      :class="{
                        'icon-rds-16':
                          dbTree.children !== undefined && dbTree.tag,
                        'icon-table-16': !dbTree.tag
                      }"
                    ></i>
                    <span
                      @click="treeClicked(node)"
                      class="k-text lable-width"
                      :class="{ 'lable-width-leaf': !dbTree.tag }"
                      style=" display:inline-block;"
                      >{{ dbTree.label }}</span
                    >
                    <div
                      @click="treeClicked(node)"
                      v-if="dbTree.children !== undefined && dbTree.tag"
                      style="position: absolute;right: 0;display:inline-block;
      line-height: 100%;
      margin-top: 7px;
      margin-right: 5px;"
                    >
                      <Tag size="mini" :type="dbTree.tagType">{{
                        dbTree.tag
                      }}</Tag>
                    </div>
                  </template>
                </Tree>
              </div>
            </template>
          </Split>
        </div>
      </Col>
      <Col span="18">
        <div class="k-card k-shadow split-box ">
          <div style="height: calc(100% - 15px);">
            <Split
              mode="vertical"
              ref="panelSplit"
              @$changed="setListHeight"
              :lastSize.sync="panelSize"
              :class="{ closed: panelSize === '0px' }"
              :min="0"
            >
              <template slot="first">
                <div class="panel" style="height:100%; position:relative">
                  <Row>
                    <Col>
                      <div style=" padding: 0 10px;">
                        <Tip type="primary" style="margin-bottom:20px;"
                          >查询引擎服务（KQES）是一个无服务器化可扩展性强的联邦查询服务。可直接对金山云RDS、KS3等不同数据中存储的数据进行查询和分析，开始创建数据库吧~</Tip
                        >
                      </div>
                      <DbItemInstruction
                        @create-db="createDb"
                      ></DbItemInstruction>
                    </Col>
                  </Row>
                </div>
              </template>
              <template slot="last">
                <div class="panel">
                  <Button type="none" icon class="close" @click="close">
                    <Icon class="ion-ios-close-empty" size="40" />
                  </Button>
                  <Input
                    placeholder="请输入"
                    style="position: absolute; right: 0;top:50px;"
                    v-if="panelInfo.type === 'DBAction'"
                    v-model="dbTableSearchText"
                    clearable
                  >
                    <template slot="prefix"
                      ><i class="ion-ios-search"></i
                    ></template>
                  </Input>
                  <span v-if="panelInfo.title" class="option-block-title">{{
                    panelInfo.title
                  }}</span>
                  <!-- 创建KS3数据库 -->
                  <div
                    v-if="panelInfo.type === 'create_ks3'"
                    class="dbpanel-form line-dep-top"
                  >
                    <Form labelWidth="140" ref="ks3form">
                      <FormItem
                        label="数据库名"
                        model="newKS3Name"
                        :rules="{
                          required: true,
                          unique: validateDBName,
                          namerule: true,
                          maxLength: 45
                        }"
                      >
                        <Input v-model="newKS3Name" />
                      </FormItem>
                      <FormItem>
                        <Button
                          type="primary"
                          @click="createKs3"
                          :loading="createDBLoading"
                          >确认</Button
                        >
                        <Button style="margin-left: 20px" @click="close"
                          >取消</Button
                        >
                      </FormItem>
                    </Form>
                  </div>
                  <!-- 导入RDS数据库 -->
                  <div
                    v-if="panelInfo.type === 'import_rds'"
                    class="dbpanel-form line-dep-top"
                  >
                    <Form labelWidth="140" ref="rdsform">
                      <FormItem
                        label="MySQL实例:"
                        model="mysqlInstanceSelected"
                        :rules="{ required: true }"
                      >
                        <Select
                          filterable
                          v-model="mysqlInstanceSelected"
                          placeholder="请选择您要查询的实例"
                          :loading="loadingInstance"
                        >
                          <Option
                            :value="i"
                            :key="i.InstanceName"
                            v-for="i in mysqlInstance"
                            >{{ i.InstanceName }}</Option
                          >
                        </Select>
                        <template slot="append">
                          <Tooltip
                            theme="light"
                            canHover
                            content="请选择您要查询的实例"
                          >
                            <Icon class="ion-ios-help-outline"></Icon>
                          </Tooltip>
                        </template>
                      </FormItem>
                      <FormItem label="授权实例只读权限">
                        <KSwitch
                          v-model="kqeReadAuth"
                          :disabled="!mysqlInstanceSelected.InstanceId"
                        >
                          <template slot="on"
                            ><i class="ion-ios-checkmark-empty"></i
                          ></template>
                          <template slot="off"
                            ><i class="ion-ios-close-empty"></i
                          ></template>
                        </KSwitch>
                      </FormItem>
                      <FormItem
                        label="数据库"
                        model="importDbName"
                        :rules="{ required: true }"
                      >
                        <template slot="append">
                          <Tooltip
                            theme="light"
                            canHover
                            content="请选择您要查询的数据库"
                          >
                            <Icon class="ion-ios-help-outline"></Icon>
                          </Tooltip>
                        </template>
                        <Select
                          v-model="importDbName"
                          filterable
                          placeholder="请选择"
                          :loading="loadingInstanceDB"
                          :disabled="!kqeReadAuth"
                        >
                          <Option
                            :value="i"
                            :key="i"
                            v-for="i in instanceDBList"
                            >{{ i }}</Option
                          >
                        </Select>
                      </FormItem>
                      <FormItem
                        label="KQES数据库"
                        model="inputDbName"
                        :rules="{
                          required: true,
                          unique: validateDBName,
                          maxLength: 45,
                          namerule: true
                        }"
                      >
                        <Input v-model="inputDbName" :disabled="!kqeReadAuth" />
                      </FormItem>
                      <FormItem>
                        <Button
                          type="primary"
                          :disabled="!kqeReadAuth"
                          @click="createMySql"
                          :loading="createDBLoading"
                          >提交</Button
                        >
                        <Button style="margin-left: 20px" @click="close"
                          >取消</Button
                        >
                      </FormItem>
                    </Form>
                  </div>
                  <!-- 表操作，创建，查看，编辑，删除 -->
                  <div
                    v-if="panelInfo.type === 'tableAction'"
                    class="dbpanel-form"
                    style="overflow: hidden"
                  >
                    <TableAction
                      :bucketList="bucketList"
                      ref="tableAction"
                      @del-clicked="tableActionDel"
                      @edit-clicked="tableActionEdit"
                      @create-clicked="dbTableCreate('ks3')"
                      @submit="tableSubmit"
                      @add-row="tableAddRow"
                      @del-row="tableDelRow"
                      @undel-row="tableUndelRow"
                      @cancel-clicked="close"
                      @query-clicked="queryTable"
                      @del-batch="delBatch"
                      @autofill-clicked="fillTable"
                      :loading="isActioningTable"
                      :dbtype="currentDbType"
                      :action="tableAction"
                      :tableDetail.sync="tableDetail"
                      :tableListHeight="tableListHeight"
                      :dataType="columnDataType"
                    ></TableAction>
                  </div>
                  <!-- 库操作，创建表，删除表 -->
                  <div
                    v-if="panelInfo.type === 'DBAction'"
                    class="dbpanel-form"
                  >
                    <DataTable
                      @del-clicked="dbDel"
                      @deltable-clicked="delTable"
                      @query="queryTable"
                      @edit-clicked="dbTableEdit"
                      @read-clicked="dbTableRead"
                      @create-clicked="dbTableCreate('ks3')"
                      :dbtype="currentDbType"
                      :tableInfo="dbTable"
                      :dbListHeight="dbListHeight"
                    ></DataTable>
                  </div>
                </div>
              </template>
              <template slot="drag">
                <Icon class="ion-drag" v-show="0" />
              </template>
            </Split>
          </div>
        </div>
      </Col>
    </Row>
    <Dialog
      v-model="showAuthModal"
      :title="modalInfo.title"
      size="small"
      @ok="onOk"
      @cancel="onCancel"
      @terminate="onCancel"
      ref="__demo"
    >
      {{ modalInfo.content }}
    </Dialog>
  </div>
</template>
<script>
import { Tooltip } from 'kpc/components/tooltip';
import { Input } from 'kpc/components/input';
import { Select, Option } from 'kpc/components/select';
import { Form, FormItem } from 'kpc/components/form';
import { Button } from 'kpc/components/button';
// import { Card, CardColumn } from 'kpc/components/card';
import Tree from 'kpc/components/tree';
import Icon from 'kpc/components/icon';
import { Row, Col } from 'kpc/components/grid';
import Split from 'kpc/components/split';
import Dialog from 'kpc/components/dialog';
import { hasEmpty } from '@/services/utils';
import { BASE_INFO } from '@/apis/meta-data';
// import Checkbox from 'kpc/components/checkbox';
import DataTable from './DataTable';
import TableAction from './TableAction';
import { Switch as KSwitch } from 'kpc/components/switch';
import Tag from 'kpc/components/tag';
import Tip from 'kpc/components/tip';
import DbItemInstruction from '@/views/meta-data/db-item-instruction';
import {
  requestDBList,
  requestCreateKs3,
  requestRDS,
  requestDBTableList,
  requestCreateHiveTable,
  requestCheckDB,
  requestRDSInstance,
  requestChangeRDSAuth,
  requestInstanceDBList,
  requestDbDrop,
  requestQueryTable,
  requestDelTable,
  requestUpdateHiveTable,
  requestShowSchema,
  // requestCheckLocation,
  requestBucketList
} from '@/apis/meta-data';
import Message from 'kpc/components/message';

// 添加全局规则
Form.addMethod(
  'namerule',
  value => {
    return /^[a-zA-Z][a-zA-z_0-9]+$/.test(value);
  },
  '字母开头，只能包含数字字母下划线'
);
Form.addMethod(
  'ks3location',
  value => {
    return /^ks3:\/\/([\w.]+\/?)\S*/.test(value);
  },
  '需要以 ks3:// 开头'
);

const ACTION_TYPE = {
  createKS3Db: {
    title: '创建KS3数据库',
    type: 'create_ks3'
  },
  createRDSDB: {
    title: '导入RDS数据库',
    type: 'import_rds'
  }
};
// const DB_TYPE = ['RDS', 'ks3'];
const TABLE_ACTION = {
  read: 'read',
  edit: 'edit',
  create: 'create'
};
const tableDetail = JSON.stringify({
  TableName: '',
  location: '',
  DataType: 'TEXTFILE',
  Separation: ',',
  path: '',
  dataType: '',
  Columns: [
    {
      ColumnName: '',
      ColumnType: 'STRING',
      ColumnComment: '',
      demo: ''
    }
  ],
  IsPartition: '0',
  PartitionColumns: [
    {
      PartitionName: '',
      PartitionType: 'STRING'
    }
  ],
  PartitionSeparation: '=',
  Granularity: 'm5',
  TimingSync: '0',
  DateFormat: 'yyyyMMdd HH mm',
  SkipHeaderLines: 0
});
const TABLE_COLUMNS = ['ColumnComment', 'ColumnType', 'ColumnName'];
export default {
  inject: ['global'],
  name: 'metadata',
  data() {
    return {
      dbConnector: '',
      createDBLoading: false,
      dbListHeight: '',
      tableListHeight: '',
      // 新的ks3数据库名
      newKS3Name: '',
      // 新建rds数据库
      mysqlInstanceSelected: '',
      mysqlInstance: [],
      importDbName: '',
      instanceDBListObj: {},
      dbTableListObj: {},
      inputDbName: '',
      kqeReadAuth: false,
      instanceDBList: [],
      nameChecked: false,
      done: false,
      loadingInstance: true,
      loadingInstanceDB: true,
      // 授权弹窗
      showAuthModal: false,
      modalInfo: {
        title: '',
        content: ''
      },
      isActioningTable: false,
      dbTableSearchText: '',
      // 数据库类型描述
      dbType: BASE_INFO.dbType,
      currentDbType: {
        type: '',
        instance: '',
        db: '',
        table: ''
      },
      // 弹出层大小, 类型, 标题
      panelSize: '0px',
      panelInfo: { type: '', title: '' },

      // 表操作, 'read', 'edit'
      tableAction: 'read',
      tableDetail: JSON.parse(tableDetail),
      columnDataType: [
        'BOOLEAN',
        'TINYINT',
        'INT',
        'SMALLINT',
        'BIGINT',
        'FLOAT',
        'DOUBLE',
        'STRING'
      ],
      bucketList: [],
      // 库操作
      dbTable: [],
      // 选中的key和展开的key
      dbSize: '0px',
      selectedKeys: [],
      expandedKeys: [],
      // key用label拼起来，数据库的key就是数据库类型+数据库名，表key，类型+db+tableName
      dbTree: [],
      showDBTree: true
    };
  },
  destroyed() {
    this.$EventBus.$off('REGION_CHANGED', this.updateRegion);
  },
  created() {
    // this.dbTableCreate('ks3');
    // this.open();
    this.init();
    this.mysqlInstance = [];
    this.$EventBus.$on('REGION_CHANGED', this.updateRegion);
  },
  watch: {
    mysqlInstanceSelected(newV) {
      this.kqeReadAuth = newV.InstanceAuth;
      if (this.kqeReadAuth) {
        this.getInstanceDBList();
      }
    },
    kqeReadAuth(newV) {
      // this.$refs.rdsform.reset()
      // 授权
      if (newV && !this.mysqlInstanceSelected.InstanceAuth) {
        this.modalInfo.type = 1;
        this.modalInfo.title = '确认授权';
        this.modalInfo.content = `请您确认授予KQES在${this.mysqlInstanceSelected.InstanceName}实例的只读权限`;
        this.authShow();
      } else if (this.mysqlInstanceSelected.InstanceAuth && !newV) {
        // 关闭授权
        this.modalInfo.type = 0;
        this.modalInfo.title = `您确认要取消KQES在${this.mysqlInstanceSelected.InstanceName}实例的只读权限吗`;
        this.modalInfo.content =
          '提示：若取消授权，该实例在KQES所有数据都会被删除，请谨慎操作（对源数据无影响）';
        this.authShow();
      }
    },
    expandedKeys() {
      // if ()
    },
    dbTableSearchText() {
      this.searchTable();
    }
  },
  computed: {
    // instanceDBList () {
    //   return this.instanceDBListObj[this.mysqlInstanceSelected.InstanceId]
    // }
  },
  mounted() {
    this.setListHeight(this.$refs.panelSplit);
  },
  methods: {
    updateRegion() {
      this.init();
      // 清空数据库实例
      this.mysqlInstance = [];
      this.close();
    },
    queryTable(table) {
      const { href } = this.$router.resolve({
        name: 'qeQuery',
        query: {
          db: this.currentDbType.db,
          table: table.TableName
        }
      });
      window.open(href, '_blank');
    },
    updateTree() {
      this.showDBTree = false;
      this.$nextTick(() => {
        this.showDBTree = true;
      });
    },
    setListHeight(instance) {
      let clientHeight = instance.refs.last.clientHeight;
      let titleHeight = 30;
      let paddingTop = 10;
      let actionBtnHeight = 95;
      let formItemHeight = 390;
      setTimeout(() => {
        this.dbListHeight =
          clientHeight - titleHeight - paddingTop - actionBtnHeight;
        this.tableListHeight =
          clientHeight - titleHeight - paddingTop - formItemHeight;
      }, 100);
      // this.$nextTick(() => {

      // })
    },
    // 数据库表搜索
    searchTable() {
      let db = this.currentDbType.db;
      if (!this.dbTableSearchText) {
        let temp = this.dbTableListObj[db] || [];
        this.$set(this, 'dbTable', temp);
        this.$forceUpdate();
        return;
      }
      this.dbTable = this.dbTableListObj[db].filter(table => {
        return table.TableName.indexOf(this.dbTableSearchText + '') >= 0;
      });
    },
    // 获取rds实例列表
    getInstanceDBList() {
      let dbList =
        this.instanceDBListObj[this.mysqlInstanceSelected.InstanceId] || [];
      if (dbList.length) {
        this.instanceDBList = dbList;
        this.loadingInstanceDB = false;
        return;
      }
      this.showLoading();
      this.instanceDBList = [];
      let params = {
        InstanceId: this.mysqlInstanceSelected.InstanceId
      };
      requestInstanceDBList(params).then(
        res => {
          // 保存实例数据库列表
          this.loadingInstanceDB = false;
          this.instanceDBListObj[this.mysqlInstanceSelected.InstanceId] =
            res.data.Data;
          this.instanceDBList = this.instanceDBListObj[
            this.mysqlInstanceSelected.InstanceId
          ];
          this.hideLoading();
        },
        err => {
          this.loadingInstanceDB = false;
          this.hideLoading();
          Message['error'](`失败: ${err.msg}`);
        }
      );
    },
    validateDBName(value) {
      return new Promise((resolve, reject) => {
        if (this.done) {
          resolve(true);
        }
        // if (this.nameChecked && this.dbConnector === 'rds') {
        //   resolve(true);
        // }
        // this.showLoading();
        requestCheckDB({
          DatabaseName: value,
          connector: this.dbConnector
        }).then(
          () => {
            // this.hideLoading();
            // if (this.dbConnector === 'rds') {
            //   this.nameChecked = true;
            // }
            resolve(true);
          },
          err => {
            // this.hideLoading();

            reject({ message: `${err.msg}` });
          }
        );
      });
    },
    // 初始化页面，数据库列表
    async init() {
      this.showLoading();
      try {
        let res = await requestDBList();
        this.dbTree = res.data.Data;
      } catch (error) {
        console.log(error);
        Message['error'](`${error.msg}`);
      }
      this.hideLoading();
    },
    dbTableRead(row) {
      this.panelInfo.type = 'tableAction';
      this.panelInfo.title = '查看数据表';
      this.tableActionRead();
      let TableName = row.TableName;
      let DatabaseName = this.currentDbType.db;
      let type = this.currentDbType.type;
      this.getTableDetail({ TableName, DatabaseName, type });
    },
    async checkDBName(value) {
      let res = true;
      if (this.newKS3Name && this.$refs.ks3form) {
        res = await this.$refs.ks3form.validate();
      } else {
        res = await this.$refs.rdsform.validate();
      }
      return requestCheckDB({
        DatabaseName: value,
        connector: this.dbConnector
      }).then(
        () => {
          return res;
        },
        () => {
          return false;
        }
      );
    },
    // 确认创建ks3数据库
    async createKs3() {
      this.createDBLoading = true;
      // let isValid = await this.$refs.ks3form.validate();
      // let err = this.$refs.ks3form.getFirstInvalidFormItem();
      try {
        let isValid = await this.checkDBName(this.newKS3Name);
        if (!isValid) {
          this.createDBLoading = false;
          return;
        }
        this.$nextTick(() => {
          this.createDBLoading = true;

          let params = {
            DatabaseName: this.newKS3Name
          };
          requestCreateKs3(params).then(
            res => {
              this.createDBLoading = false;
              this.done = true;
              console.log('createKs3:', res);
              Message['success']('数据库创建成功');
              // 刷新数据库列表
              this.init();
              // 选中数据库
              this.selectedKeys = [`ks3+${this.newKS3Name}`];
              // 跳转到创建表
              this.currentDbType.db = this.newKS3Name;
              this.dbTableCreate('ks3');
              // this.close();
            },
            err => {
              this.createDBLoading = false;
              console.log('requestCreateKs3:', err);
              Message['error'](`数据库创建失败: ${err.msg}`);
            }
          );
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 获取rds实例
    getRdsInstance() {
      // 不重复获取
      if (this.mysqlInstance.length) {
        this.loadingInstance = false;
        return;
      }
      this.showLoading();
      requestRDSInstance().then(
        res => {
          console.log('getRdsInstance:', res);
          this.mysqlInstance = res.data.Data;
          this.hideLoading();
          this.loadingInstance = false;
        },
        err => {
          this.loadingInstance = false;
          console.log('getRdsInstance:', err);
          Message['error'](`操作失败: ${err.msg}`);
          this.hideLoading();
        }
      );
    },
    // 确认创建rds数据库
    async createMySql() {
      this.createDBLoading = true;
      try {
        let isValid = await this.checkDBName(this.inputDbName);
        if (!isValid) {
          this.createDBLoading = false;
          return;
        }
        console.log('提交， createMySql');
        this.showLoading();
        this.createDBLoading = true;

        let params = {
          InstanceId: this.mysqlInstanceSelected.InstanceId,
          DatabaseName: this.importDbName,
          AliasName: this.inputDbName
        };
        requestRDS(params).then(
          res => {
            this.createDBLoading = false;
            this.done = true;
            console.log('createMySql:', res);
            Message['success']('操作成功');
            this.close();
            this.init();
            this.hideLoading();
          },
          err => {
            this.createDBLoading = false;

            console.log('createMySql:', err);
            Message['error'](`数据库创建失败: ${err.msg}`);
            this.hideLoading();
          }
        );
      } catch (error) {
        this.createDBLoading = false;
        console.log(error);
      }
    },
    // 打开创建或导入数据库面板
    createDb(db) {
      if (!db.action) {
        return;
      }
      this.dbConnector = db.type;
      if (this.dbConnector === 'rds') {
        this.getRdsInstance();
      }
      this.done = false;
      this.panelInfo.type = ACTION_TYPE[db.action].type;
      this.panelInfo.title = ACTION_TYPE[db.action].title;
      this.open();
    },
    // 获取库表列表
    getDBTable(node) {
      let DatabaseName = node.data.label;
      let params = {
        DatabaseName,
        type: node.data.key.split('+')[0]
      };
      console.log(node, 11111);
      return new Promise(resolve => {
        requestDBTableList(params).then(
          res => {
            // node.loaded = true
            this.dbTableListObj[DatabaseName] = res.data.Data;
            resolve(res.data.Data);
          },
          err => {
            Message['error'](`${err.msg}`);
            this.$nextTick(() => {
              node.loaded = false;
              delete node.loaded;
              node.abc = false;
              console.log(node);
            });
            node.children = [];
            resolve(false);
          }
        );
      });
    },
    // 点击创建数据库
    createDBClicked() {
      this.selectedKeys = [];
      this.close();
    },
    // 打开操作数据表面板
    treeClicked(node) {
      // console.log('treeClicked:', node.key, this.selectedKeys, this.expandedKeys);
      // 根据key区分选择的类型，每层按照加号来区分
      let keys = node.key.split('+');
      let dbType = keys[0];
      let db = keys[1];
      let table = keys[2];
      if (table && hasEmpty(table)) {
        this.Message.error('表名不合法，导入失败');
        return;
      }
      this.selectedKeys = [node.key];
      // 当前操作的数据库类型
      this.currentDbType.type = dbType;
      this.currentDbType.db = db;
      this.currentDbType.table = table;

      console.log('this.currentDbType:', keys);
      if (table) {
        this.panelInfo.type = 'tableAction';
        this.panelInfo.title = '查看数据表';
        this.tableAction = TABLE_ACTION.read;
        this.getTableDetail({
          TableName: table,
          DatabaseName: db,
          type: dbType
        });
      } else if (db) {
        this.panelInfo.type = 'DBAction';
        this.panelInfo.title = '查看数据库';

        // 直接取缓存的表
        if (this.dbTableListObj[db] && this.dbTableListObj[db].length) {
          // this.dbTable = this.dbTableListObj[db];
          console.log('from cache: ', db, this.dbTableListObj);
          this.searchTable();
        } else {
          let params = {
            DatabaseName: db,
            type: dbType
          };
          this.showLoading();
          requestDBTableList(params).then(
            res => {
              // node.loaded = true
              // this.dbTable = res.data.data;
              console.log(res.data);
              this.dbTableListObj[db] = res.data.Data;
              console.log('from server: ', db, this.dbTableListObj);
              this.searchTable();
              this.hideLoading();
            },
            err => {
              this.hideLoading();
              this.Message.error(err.msg);
            }
          );
        }
      } else {
        // 顶层数据库类型，不做操作
        return;
      }
      this.open();
    },
    getTableDetail({ TableName, DatabaseName, type }) {
      this.showLoading();
      let params = {
        TableName,
        DatabaseName,
        type
      };
      requestQueryTable(params).then(
        res => {
          this.hideLoading();
          let tableInfo = res.data.Total;
          tableInfo.TimingSync = tableInfo.TimingSync ? '1' : '0';
          tableInfo.Granularity = tableInfo.Granularity
            ? tableInfo.Granularity
            : 'm5';
          this.tableDetail = tableInfo;
          console.log(this.tableDetail);
        },
        err => {
          this.hideLoading();
          this.tableDetail = {};
          console.log('requestQueryTable:', err);
          Message['error'](`失败: ${err.msg}`);
        }
      );
    },
    // 表操作
    tableActionRead() {
      console.log('tableActionRead');
      this.tableAction = TABLE_ACTION.read;
    },
    tableActionEdit() {
      this.tableAction = TABLE_ACTION.edit;
      this.panelInfo.title = '编辑数据表';
    },
    tableActionCreate() {
      console.log('tableaction create');
    },
    delTable(table) {
      this.currentDbType.table = table.TableName;
      this.tableActionDel(true, table.index);
    },
    tableActionDel(isListDel, index) {
      Dialog['confirm']({
        title: '您确认要删除该数据表吗？',
        content: '提示: 该操作只删除KQES的表结构，对源数据无影响'
      }).then(
        () => {
          this.showLoading();
          let DatabaseName = this.currentDbType.db;
          let params = {
            DatabaseName,
            TableName: this.currentDbType.table
          };
          requestDelTable(params).then(
            res => {
              console.log(res);
              Message['success']('成功');
              if (isListDel) {
                this.appendNewTable();
                this.dbTableListObj[DatabaseName].splice(index, 1);
              } else {
                this.appendNewTable();
                this.close();
              }

              this.hideLoading();
            },
            err => {
              this.hideLoading();

              Message['error'](`失败: ${err.msg}`);
            }
          );
          console.log('clicked ok button');
        },
        () => {
          console.log('clicked cancel button');
        }
      );
      console.log('tableActionDel');
    },
    makeTable(table) {
      let DatabaseName = this.currentDbType.db || this.selectedKeys;
      let TableName = table.TableName || this.currentDbType.db;
      let Location = table.Location;
      let Path = table.Path;
      let Bucket = table.Bucket;
      let Stored = table.DataType;
      let Separation =
        table.Separation === 'custom' ? table.splitCustom : table.Separation;
      let ColumnName = [];
      let ColumnType = [];
      let ColumnComment = [];
      let deleteList = [];
      let addListObj = {
        ColumnComment: [],
        ColumnType: [],
        ColumnName: []
      };
      for (let i = 0; i < table.Columns.length; i++) {
        let row = table.Columns[i];
        if (this.tableAction === TABLE_ACTION.create && !row.isDel) {
          ColumnName.push(row.ColumnName);
          ColumnType.push(row.ColumnType);
          ColumnComment.push(row.ColumnComment);
        }
        if (row.isAdded && !row.isDel) {
          TABLE_COLUMNS.forEach(item => {
            addListObj[item].push(row[item]);
          });
        }
        if (!row.isAdded && row.isDel) {
          deleteList.push(row.ColumnName);
          // TABLE_COLUMNS.forEach(item => {
          //   deleteListObj[item].push(row[item]);
          // });
        }
      }
      if (this.tableAction === TABLE_ACTION.create) {
        let PartitionColumns = [];
        for (let i = 0; i < table.PartitionColumns.length; i++) {
          table.PartitionColumns[i].PartitionName
            ? PartitionColumns.push(table.PartitionColumns[i].PartitionName)
            : '';
        }
        return {
          DatabaseName,
          TableName,
          Path,
          Bucket,
          Stored,
          Location,
          Separation,
          ColumnComment,
          ColumnType,
          ColumnName,
          // 新增分区表参数
          IsPartition: !!(table.IsPartition - 0),
          PartitionColumns,
          PartitionSeparation: table.PartitionSeparation,
          Granularity: table.Granularity,
          TimingSync: !!(table.TimingSync - 0),
          DateFormat: table.DateFormat
            ? table.DateFormat.replace(/Y/g, 'y').replace(/D/g, 'd')
            : '',
          SkipHeaderLines: table.SkipHeaderLines + '' || 0 + ''
        };
      } else if (this.tableAction === TABLE_ACTION.edit) {
        return {
          DatabaseName,
          TableName,
          Delete: deleteList,
          Add: addListObj,
          TimingSync: !!(table.TimingSync - 0),
          DateFormat: table.DateFormat
            ? table.DateFormat.replace(/Y/g, 'y').replace(/D/g, 'd')
            : '',
          Granularity: table.Granularity
        };
      }
    },
    async tableSubmit(table) {
      this.showLoading();
      let isEdit = this.tableAction === TABLE_ACTION.edit;
      // // 创建表时查询ks3 location是否存在
      // if (!isEdit) {
      //   try {
      //     await this.checkLocation();
      //   } catch (error) {
      //     if (error.data.code === 404) {
      //       Dialog['confirm']({
      //         title: '当前存储位置不存在，确认创建表么？',
      //         content: '提示: 您可以稍后创建存储位置'
      //       }).then(
      //         () => {
      //           this.tableSubmitAction(isEdit, table);
      //         },
      //         () => {
      //           console.log('clicked cancel button');
      //         }
      //       );
      //     } else {
      //       this.Message.error(`${error.msg}`);
      //     }
      //     return;
      //   }
      // }
      this.tableSubmitAction(isEdit, table);
      this.hideLoading();
    },
    async tableSubmitAction(isEdit, table) {
      this.showLoading();
      this.isActioningTable = true;
      let params = {};
      params = { ...this.makeTable(table) };

      // if (isEdit) {
      //   params = { ...this.makeTable(table) };
      // } else {
      //   params = {
      //     mode: 'json',
      //     operate: {
      //       json: { ...this.makeTable(table) }
      //     }
      //   };
      // }
      try {
        let res = {};
        if (isEdit) {
          res = await requestUpdateHiveTable(params);
        } else {
          res = await requestCreateHiveTable(params);
          this.appendNewTable(table);
        }

        // 清空缓存的表
        this.dbTableListObj = {};
        this.close();
        this.Message.success(`${res.msg}`);
      } catch (error) {
        this.Message.error(`${error.msg}`);
      }
      this.isActioningTable = false;
      this.hideLoading();
    },
    appendNewTable() {
      let key = 'ks3+' + this.currentDbType.db || this.selectedKeys;
      this.$refs.dbTree.shrink(key);
      // let node = this.$refs.dbTree.getSelectedData()[0];
      // if (node) {
      //   node.children = [];
      // }
      this.selectedKeys = [key];
      this.updateTree();
    },
    async fillTable(data) {
      console.log(data);
      let params = {
        DataType: data.DataType,
        Split:
          data.Separation === 'custom' ? data.splitCustom : data.Separation,
        Location: data.Location,
        Bucket: data.Bucket,
        Path: data.Path || '/'
      };
      console.log(params);

      this.showLoading();
      try {
        let res = {};
        res = await requestShowSchema(params);
        res = res.data;
        let dataTable = [];
        let attribute = res.Total.Attribute;
        let column = res.Total.Column || [];
        let data = res.Total.Data || [];
        if (Array.isArray(attribute)) {
          for (let i = 0; i < attribute.length; i++) {
            dataTable.push({
              ColumnName: column[i] || '',
              ColumnType: attribute[i] || '',
              data: data[i]
            });
          }
        }
        this.tableDetail.Columns = [...dataTable];
        this.$refs.tableAction.updateTable();
      } catch (error) {
        // console.log(error)
        this.Message.error(`${error.msg}`);
      }
      this.hideLoading();
    },
    tableAddRow() {
      let temp = this.tableDetail.Columns;
      temp.push({
        ColumnName: '',
        ColumnType: 'STRING',
        ColumnComment: '',
        demo: '',
        isAdded: true
      });
      this.$set(this.tableDetail, 'columns', temp);
    },
    delBatch(batch) {
      console.log(batch, 'batch');

      batch.forEach(row => (row.isDel = true));
      this.$set(this.tableDetail, 'columns', this.tableDetail.Columns);
    },
    tableDelRow(row) {
      row.isDel = true;
    },
    tableUndelRow(row) {
      console.log('undel,', row);
      row.isDel = false;
    },
    // 库操作
    dbDel() {
      console.log('dbtabelDel');
      Dialog['confirm']({
        title: '您确认要删除该数据库吗？',
        content: '提示: 删除库同时会删除KQES表，源数据无影响'
      }).then(
        () => {
          let params = {
            DatabaseName: this.currentDbType.db,
            type: this.currentDbType.type
          };
          requestDbDrop(params).then(
            res => {
              console.log('requestDbDrop:', res);
              Message['success']('操作成功');

              this.init();
              this.close();
            },
            err => {
              console.log('requestDbDrop:', err);
              Message['error'](`失败: ${err.msg}`);
            }
          );
          console.log('clicked ok button');
        },
        () => {
          console.log('clicked cancel button');
        }
      );
    },
    async dbTableCreate(type) {
      try {
        this.showLoading();
        let res = await requestBucketList();
        this.bucketList = res.data.Data;
        this.tableAction = TABLE_ACTION.create;
        this.currentDbType.type = type;
        this.panelInfo.title = '创建数据表';
        this.panelInfo.type = 'tableAction';
        this.tableDetail = JSON.parse(tableDetail);
      } catch (err) {
        Message['error'](`失败: ${err.msg}`);
      }
      this.hideLoading();
    },
    getListBucket() {},
    dbTableEdit(row) {
      this.panelInfo.type = 'tableAction';
      this.panelInfo.title = '编辑数据表';
      this.tableActionEdit();
      let TableName = row.TableName;
      let DatabaseName = this.currentDbType.db;
      let type = this.currentDbType.type;
      this.getTableDetail({ TableName, DatabaseName, type });
    },

    getSelectedData() {},
    getPanelInfo() {
      console.log(this.panelInfo, this.tableDetail);
    },
    delField() {},
    close() {
      this.panelSize = '0px';
      // 初始化各种状态
      this.panelInfo = {
        type: '',
        title: ''
      };
      this.newKS3Name = '';
      this.mysqlInstanceSelected = '';
      this.inputDbName = '';
      this.importDbName = '';
      this.loadingInstance = true;
      this.loadingInstanceDB = true;
      this.kqeReadAuth = false;
      this.tableAction = TABLE_ACTION.read;
      this.dbTableSearchText = '';
      this.nameChecked = false;
      // if (this.$refs.rdsform) {
      //   this.$refs.rdsform.reset
      // }
      // this.$refs.rdsform.reset()
      // this.$ref.ks3form.reset()
    },
    open() {
      if (this.panelSize === '0px') {
        this.panelSize = '100%';
      }
    },
    authShow() {
      this.showAuthModal = true;
    },
    authModalClose() {
      this.showAuthModal = false;
    },
    onOk() {
      console.log('ok');
      this.changeAuthStatus();
    },
    onCancel() {
      console.log('cancel');
      this.kqeReadAuth = !this.kqeReadAuth;
    },
    changeAuthStatus() {
      let params = {
        grant: this.kqeReadAuth ? 'add' : 'cancel',
        InstanceId: this.mysqlInstanceSelected.InstanceId
      };
      this.showLoading();
      requestChangeRDSAuth(params).then(
        res => {
          console.log('requestChangeRDSAuth:', res);
          // Message['success']('创建成功');
          // 修改授权状态
          this.mysqlInstanceSelected.InstanceAuth = this.kqeReadAuth;
          // 修改实例下的数据库
          if (this.kqeReadAuth) {
            this.getInstanceDBList();
          } else {
            this.instanceDBList = [];
            this.init();
          }
          this.hideLoading();
        },
        err => {
          this.kqeReadAuth = !this.kqeReadAuth;
          console.log('requestChangeRDSAuth:', err);
          Message['error'](`失败: ${err.msg}`);
          this.hideLoading();
        }
      );
    }
  },
  components: {
    DataTable,
    Form,
    FormItem,
    Button,
    TableAction,
    // ButtonGroup,
    DbItemInstruction,
    Tag,
    Select,
    Option,
    Input,
    Tip,
    // Table,
    // TableColumn,
    Tooltip,
    Dialog,
    // Checkbox,
    Icon,
    Tree,
    // Card,
    // CardColumn,
    Split,
    Row,
    Col,
    KSwitch
  }
};
</script>
<style lang="stylus" scoped>
.can-click:hover {
  // background: #e5f7ff;
  cursor:pointer;
  transform:scale(1.02)
  box-shadow: 10px 10px 5px #EFEFEF;
}
.split-box {
  background: #fff;
  height: calc(100vh - 120px);
  padding: 10px 12px 0;
}

.last-border {
  border-top: 1px solid #EFEFEF;
  height: 100%;
}

.action-btn {
  position: absolute;
  right: 15px;
  bottom: 10px;
}
.meta-data .k-split.k-vertical > .k-line-wrapper {
  display: none;
}
.meta-data .k-first{
  border-bottom: none;
}
.dbpanel-form {
  margin-top: 20px;
}
.lable-width {
  width: calc(100% - 60px)
}
.lable-width-leaf {
  width: calc(100% - 15px)
}
.k-form-item .k-label {
  color: #666;
  font-size: 14px;
  display: inline-block;
  font-weight: normal;
  margin: 0;
}
.k-tree .k-label {
  position: inherit;
}
.k-node .k-selected{
  background: #e5f7ff!important;
}
.k-tree .k-node.k-selected > .k-label {
  background: #e5f7ff;
}
.k-tree .k-node.k-selected > .k-label .k-text {
  background: none;
}
.k-tree .k-node.k-selected > .k-label:hover {
  background: #e5f7ff;
}

.k-tree .k-label:hover {
  background: #f1f1f5;
}
.k-tree .k-node .k-node:hover {
  background: #f1f1f5;
}
.disabled-bg {
  background: #f1f1f5
  }
</style>
